import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c('ListActionsVue'),_c(VRow,[_c(VCol,{attrs:{"cols":"12","md":"12","lg":"12","sm":"12","xs":"12"}},[_c('InventoryListVue')],1),_c(VCol,{attrs:{"cols":"12","md":"6","lg":"6","sm":"12","xs":"12"}},[_c('InventoryCategoryChartVue')],1),_c(VCol,{attrs:{"cols":"12","md":"6","lg":"6","sm":"12","xs":"12"}},[_c('InventoryLocationChartVue')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }